import { useParams, Navigate } from "react-router-dom";
import CandidateDocs from "./CandidateDocs";

export default function Resubmit() {
  const { token } = useParams();
  if (!token) return <Navigate to="/" replace />;
  return (
    <div className="min-h-screen bg-nx-navy flex items-center justify-center px-4 py-12" data-testid="resubmit-page">
      <div className="w-full max-w-xl">
        <img src="/assets/logo-signature-dark.png" alt="NexSecure Technologies" className="h-24 mx-auto mb-6" />
        <div className="border border-white/10 bg-white/[0.03] p-5 sm:p-8">
          <CandidateDocs token={token} resubmitOnly />
        </div>
      </div>
    </div>
  );
}
